<template>
  <div class="social-links">
    <Paw />
    <h2 class="section-header">Our Community</h2>
    <div class="link-container">
      <div class="link" tabindex="0">
        <a href="https://www.facebook.com/groups/Dating4Pets" target="_blank">
          <fa class="icon" :icon="['fab', 'facebook']" id="fb-icon" />
          <!-- Facebook -->
        </a>
      </div>
      <VerticalBreak />
      <div class="link" tabindex="0">
        <a href="https://www.instagram.com/dating4pets" target="_blank">
          <fa class="icon" :icon="['fab', 'instagram']" id="ig-icon" />
          <!-- Instagram -->
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import Paw from "./stylistics/Paw.vue";
import VerticalBreak from "./stylistics/VerticalBreak.vue";
export default {
  name: "Socials",
  components: { Paw, VerticalBreak },
};
</script>

<style scoped>
.link-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  overflow: visible;
}

.link {
  border-radius: var(--border-radius);
  transition: var(--transition);
  background: var(--light-clr);
  box-shadow: var(--light-box-shadow);
}

.link:hover,
.link:focus {
  background: var(--faint-bg);
  /* box-shadow: var(--box-shadow-focus); */
}

.link:hover #fb-icon,
.link:focus #fb-icon {
  --dark-clr: var(--facebook);
}

.link:hover #ig-icon,
.link:focus #ig-icon {
  --dark-clr: var(--instagram);
}

.link a {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1em;
  text-decoration: none;
}

.icon {
  /* transform: scale(4); */
  --dark-clr: var(--primary-clr);
  min-width: 4em;
  height: 80%;
  max-width: 20em;
  aspect-ratio: 1;
  margin: 2em;
  transition: var(--transition);
}

@media screen and (max-width: 30rem) {
  .vertical-break {
    display: none;
  }
  .link-container {
    flex-direction: column;
    gap: calc(var(--gap) + 1em);
  }
}

.social-links {
  width: 100%;
  overflow: visible;
}
</style>
